import { Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import TabPanel from "../../components/TabPanel";
import JobsList from "./JobsList";

export default function Jobs() {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange} aria-label="tabs">
        <Tab label="Jobs" />
      </Tabs>
      <TabPanel value={tabValue} index={0}>
        <JobsList />
      </TabPanel>
    </>
  );
}
